export default __webpack_public_path__ + "static/Dinish-Bold-d677f864af0b93e9f41bbf158da94284.ttf";